export default __webpack_public_path__ + "static/media/menu_outages.8c090222.svg";